import { APP_ROUTES, useAppSelector, useAppTranslation } from "@/utils";
import { bnplConsumerApis } from "@payping/api";
import { CheckCircleFilled, FiDownload } from "@payping/icons";
import { Button, Copy, Flex, Typography, theme, useMessagedAsyncFn } from "@payping/web-components";
import { Link } from "react-router";
import { useAsync } from "react-use";

interface SuccessProps {
  data: string;
}
const KuknosPaymentCallbackPageSuccess = (props: SuccessProps) => {
  const { t } = useAppTranslation();
  const { token } = theme.useToken();
  const trackingCode = useAppSelector((state) => state.dashboardPersist.trackingCode);

  const dataState = useAsync(async () => {
    try {
      const res = JSON.parse(props.data);
      return res;
    } catch {
      return undefined;
      /* empty */
    }
  }, [props.data]);

  const [downloadState, download] = useMessagedAsyncFn(
    (fileName: string) => bnplConsumerApis.getDownloadPath(fileName),
    [],
  );

  const downloadFile = async (fileName: string) => {
    try {
      const res = await download(fileName);
      if (!res.url) return;
      const link = document.createElement("a");
      link.href = res.url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch {
      /* empty */
    }
  };

  return (
    <Flex vertical className="tw:h-full tw:w-full tw:p-4!">
      <Flex className="tw:my-auto tw:w-full" vertical gap={"large"} align="center">
        <CheckCircleFilled width={80} className="tw:fill-color-success" />

        <Typography.Title level={5} className="tw:m-0! tw:font-semibold">
          {t("pay.getOrder.steps.payPromissory.successTitle")}
        </Typography.Title>
        <Flex vertical style={{ backgroundColor: token.colorBgLayout }} className="tw:w-full tw:p-4!" gap={"middle"}>
          <Flex wrap justify="space-between" className="tw:w-full">
            <Typography.Text type="secondary">{t("common.treasuryId")}</Typography.Text>
            <Typography.Text>{dataState.value?.treasuryId ?? ""}</Typography.Text>
          </Flex>
          <Flex wrap justify="space-between" className="tw:w-full">
            <Typography.Text type="secondary">{t("common.trackingCode")}</Typography.Text>
            <Copy isButton showIcon text={trackingCode}>
              {trackingCode}
            </Copy>
          </Flex>
          {typeof dataState.value?.signedPdf === "string" ? (
            <Flex wrap justify="space-between" className="tw:w-full">
              <Typography.Text type="secondary">{t("common.downloadPromissory")}</Typography.Text>
              <Button
                loading={downloadState.loading}
                onClick={async () => {
                  await downloadFile(dataState.value?.signedPdf);
                }}
                icon={<FiDownload width={12} height={12} />}
              >
                {t("common.downloadFile")}
              </Button>
            </Flex>
          ) : null}
        </Flex>
      </Flex>
      <Flex align="center" className="tw:mt-auto tw:w-full" gap={"middle"}>
        <Link className="tw:flex tw:w-full" to={`${APP_ROUTES.pay.getOrder.root.url}?trackingCode=${trackingCode}`}>
          <Button type="primary" block>
            {t("common.confirm")}
          </Button>
        </Link>
      </Flex>
    </Flex>
  );
};

export default KuknosPaymentCallbackPageSuccess;
